import Vue from 'vue';
import Component from 'vue-class-component';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import * as ctpfront_pb from '@/../static/js/proto/CtpFront_pb';
import { mapGetters } from 'vuex';
import * as utils from '@/utils/utils';
import ConditionUpdate from '../ConditionUpdate/ConditionUpdate.vue';
import _ from 'lodash';
import * as SubUtils from '@/store/SubUtils';

/**
 * 未触发条件单
 */
@Component({
  components: {
    ConditionUpdate,
  },
  computed: {
    ...mapGetters({
      conditionNotTriggerList: 'Params/conditionNotTriggerList',
    }),
  },
})
export default class ConditionNotTrigger extends Vue {

  public conditionNotTriggerList: IOrderConditional[];
  public isShowUpdate = false;
  public currentSelect: IOrderConditional = {} as any;
  public typeArr: any = [];
  public isDeletingAll = false;
  public showFeedbackToast = false;
  public feedbackMessage = '';
  public feedbackType = 'success';
  public feedbackToastTimer = null;

  public get priceTickN() {
    return this.typeArr.priceTick;
  }

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'contract',
    },
    {
      text: '状态',
      width: '1.5rem',
      name: 'state',
    },
    {
      text: '条件',
      width: '1.5rem',
      name: 'condition',
    },
    {
      text: '下单',
      width: '3rem',
      name: 'order',
    },
    {
      text: '有效期',
      width: '2rem',
      name: 'effective',
    },
    {
      text: 'ID',
      width: '6rem',
      name: 'id',
    }];
  public get tableData() {
    const arr: any[] = [];
    for (const item of this.conditionNotTriggerList) {
      if ((item as any).orderType === 0) {
        arr.push({
          contract: item.targetId,
          state: ConditionData.getState(item),
          condition: ConditionData.getCondition(item),
          order: ConditionData.getOrder(item),
          effective: ConditionData.getText(ConditionData.validTime,
            item.validTime),
          id: item.id,
          stopText: item.state === front.con_order_run ? '暂停' : '启动',
        });
      }
    }
    return arr;
  }
  public destroyed() {
    // SubUtils.unSub('conditionNotTriggerList');
  }
  public beforeDestroy() {
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
      this.feedbackToastTimer = null;
    }
  }
  public openFeedbackToast(message, type = 'error', duration = 2000) {
    this.feedbackMessage = message;
    this.feedbackType = type;
    this.showFeedbackToast = true;
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
    }
    this.feedbackToastTimer = setTimeout(() => {
      this.showFeedbackToast = false;
      this.feedbackToastTimer = null;
    }, duration) as any;
  }

  public deactivated() {
    // SubUtils.unSub('conditionNotTriggerList');
  }
  public handleStop(item: IOrderConditional) {
    console.log(item);
    const cond = new ctpfront_pb.OrderConditional();
    const data = _.find(this.conditionNotTriggerList, r => r.id === item.id)!;
    cond.setId(data.id);
    cond.setTargetId(data.targetId);
    cond.setPrice(data.price);
    cond.setConditionPriceType(front.con_last_price);
    cond.setOperationType(data.operationType);
    cond.setVolume(data.volume);
    cond.setDirection(data.direction);
    cond.setOffset(data.offset);
    cond.setValidTime(data.validTime);
    cond.setOrderPrice(data.orderPrice);
    cond.setOrderPriceType(data.orderPriceType);

    if (data.state === front.con_order_run) {
      cond.setState(front.con_order_stop);
    } else {
      cond.setState(front.con_order_run);
    }

    utils.indicator('正在处理...');
    front.conditionOrderSave(cond, resolve => {
      utils.closeIndicator();
      this.openFeedbackToast('云条件单操作成功', 'success', 2200);
      console.log(resolve);
    }, reject => {
      console.error(reject);
      this.openFeedbackToast('云条件单操作失败: ' + reject.message, 'error', 2600);
      utils.closeIndicator();
    });
  }
  public async handleDel(item: IOrderConditional) {

    try {
      await utils.confirm('确认删除此条件单吗？', '删除？', '确定', '取消');
    } catch (e) {
      console.log(e);
      return;
    }

    utils.indicator('正在处理...');
    front.conditionOrderRemove('', '',
      item.id, resolve => {
        utils.closeIndicator();
        this.openFeedbackToast('删除云条件单成功', 'success', 2200);
      }, reject => {
        this.openFeedbackToast('删除云条件单失败: ' + reject.message, 'error', 2600);
        utils.closeIndicator();
      });
  }
  public removeConditionById(id: string) {
    return new Promise((resolve, reject) => {
      front.conditionOrderRemove('', '',
        id, result => {
          resolve(result);
        }, error => {
          reject(error);
        });
    });
  }
  public async handleDeleteAll() {
    const targetList = this.tableData.slice();
    if (!targetList.length || this.isDeletingAll) {
      return;
    }

    try {
      await utils.confirm(`确认删除全部${targetList.length}条未触发条件单吗？`, '全部删除？', '确定', '取消');
    } catch (e) {
      return;
    }

    this.isDeletingAll = true;
    let failedCount = 0;
    utils.indicator('正在删除...');
    try {
      for (const item of targetList) {
        try {
          await this.removeConditionById(item.id);
        } catch (e) {
          failedCount++;
          console.error(e);
        }
      }
    } finally {
      this.isDeletingAll = false;
      utils.closeIndicator();
    }

    if (!failedCount) {
      this.openFeedbackToast('已全部删除云条件单', 'success', 2200);
      return;
    }
    if (failedCount === targetList.length) {
      this.openFeedbackToast('全部删除云条件单失败', 'error', 2600);
      return;
    }
    this.openFeedbackToast(`已删除${targetList.length - failedCount}条云条件单，失败${failedCount}条`, 'error', 2600);
  }
  public handleUpdate(item: IOrderConditional) {
    // tslint:disable-next-line:no-string-literal
    this.typeArr = front['targetSet'][item.contract];
    this.$store.commit('priceTick/changePriceT', this.typeArr.priceTick);
    // this.typeArr = front.subTick(item.contract, 'trade-detail');
    this.currentSelect = _.find(this.conditionNotTriggerList,
      r => r.id === item.id)!;
    this.isShowUpdate = true;
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionNotTrigger/ConditionNotTrigger.ts